import { InjectionToken } from '@angular/core';

export interface CapicheMixpanelConfig {
  envName: string;
  mixpanelToken: string;
  enabled?: boolean;
  sessionPercent?: number;
}

export const CAPICHE_MIXPANEL_CONFIG = new InjectionToken<CapicheMixpanelConfig>('CapicheMixpanelConfig');
